import { CameraOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import html2canvas from 'html2canvas';
import React from 'react';

export interface ScreenShotterProps {
  triggerNode?: React.ReactNode;
}

export default function ScreenShotter(props: ScreenShotterProps) {
  async function handleScreenshot() {
    // hide footer before taking screenshot
    const footer = document.getElementById('decaf-footer');
    footer?.style.setProperty('display', 'none');

    const canvas = await html2canvas(document.body);
    const dataUrl = canvas.toDataURL('image/png');

    // show footer after taking screenshot
    footer?.style.setProperty('display', 'block');

    const link = document.createElement('a');
    link.download = 'screenshot.png';
    link.href = dataUrl;
    link.click();
    link.remove();
  }

  if (props.triggerNode) {
    return React.cloneElement(props.triggerNode as React.ReactElement<any>, {
      onClick: handleScreenshot,
    });
  }

  return (
    <Button
      type="text"
      icon={<CameraOutlined />}
      title="Take a screenshot of the current page"
      onClick={handleScreenshot}
    />
  );
}
